import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import ELearningCreditsSection from 'components/settings/billing/ELearningCreditsSection';

export default function ELearningCreditsSectionWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <ELearningCreditsSection {...wrappedProps} />
    </AppWrapper>
  );
}
